import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const links = [
  { label: 'The work', href: '#stories' },
  { label: 'Philosophy', href: '#philosophy' },
  { label: 'Experience', href: '#experience' },
  { label: 'Journal', href: '#journal' },
  { label: 'Kind words', href: '#kind-words' },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <a className="wordmark" href="#home" aria-label="Still and Story home">
        still <span>&</span> story.
        <small>PHOTOGRAPHY STUDIO</small>
      </a>
      <nav className={menuOpen ? 'main-nav is-open' : 'main-nav'} aria-label="Main navigation">
        {links.map((link) => (
          <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)}>{link.label}</a>
        ))}
        <a className="nav-cta" href="#contact" onClick={() => setMenuOpen(false)}>Let’s talk</a>
      </nav>
      <button
        className="menu-toggle"
        type="button"
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <SafeIcon icon={menuOpen ? FiX : FiMenu} />
      </button>
    </header>
  );
}

export default Header;
